import React from 'react';

export const TypingIndicator = () => {
  return (
    <div className="flex items-center gap-1 py-2">
      <div 
        className="w-2 h-2 rounded-full typing-dot"
        style={{ backgroundColor: '#D97757' }}
      />
      <div 
        className="w-2 h-2 rounded-full typing-dot"
        style={{ backgroundColor: '#D97757' }}
      />
      <div 
        className="w-2 h-2 rounded-full typing-dot"
        style={{ backgroundColor: '#D97757' }}
      />
    </div>
  );
};

export default TypingIndicator;
